export { BASE_URL, API_GROUP, API_VERSION } from './baseAPI';
import { generatedAPI as rawAPI } from './endpoints.gen';

export * from './endpoints.gen';

// Only invalidate the DashboardTemplate tag on successful mutations. The generated
// endpoints use the static-array form of invalidatesTags, which RTK Query applies
// regardless of success or failure — that triggers a background refetch on a 409,
// clobbering in-progress form edits before the user can react to the conflict alert.
const invalidateOnSuccess = (result: unknown, error: unknown) =>
  error ? [] : (['DashboardTemplate'] as const);

export const generatedAPI = rawAPI.enhanceEndpoints({
  endpoints: {
    createDashboardTemplate: { invalidatesTags: invalidateOnSuccess },
    replaceDashboardTemplate: { invalidatesTags: invalidateOnSuccess },
    deleteDashboardTemplate: { invalidatesTags: invalidateOnSuccess },
  },
});

export { generatedAPI as dashboardtemplatesAPIv1alpha1 };
